import { render, staticRenderFns } from "./livePdfPage.vue?vue&type=template&id=3940900e&"
import script from "./livePdfPage.vue?vue&type=script&lang=ts&"
export * from "./livePdfPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports